/* eslint-disable  @typescript-eslint/no-explicit-any */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { client } from '../../commons/httpCommon';
import { USE_MOCKS } from '../../constants/constants';

export class HttpService {
  public static get<T>(url: string, config: AxiosRequestConfig, mock: any): Promise<AxiosResponse<T>> {
    if (USE_MOCKS) {
      return mock;
    }
    return client.get<T>(url, config);
  }

  public static post<T>(url: string, data: any, config: AxiosRequestConfig, mock: any): Promise<AxiosResponse<T>> {
    if (USE_MOCKS) {
      return mock;
    }
    return client.post<T>(url, data, config);
  }

  public static patch<T>(url: string, data: any, config: AxiosRequestConfig, mock: any): Promise<AxiosResponse<T>> {
    if (USE_MOCKS) {
      return mock;
    }
    return client.patch<T>(url, data, config);
  }

  public static put<T>(url: string, data: any, config: AxiosRequestConfig, mock: any): Promise<AxiosResponse<T>> {
    if (USE_MOCKS) {
      return mock;
    }
    return client.put<T>(url, data, config);
  }

  public static delete<T>(url: string, config: AxiosRequestConfig, mock: any): Promise<AxiosResponse<T>> {
    if (USE_MOCKS) {
      return mock;
    }
    return client.delete<T>(url, config);
  }
}
